import { isZero, enableCoveragePeriod, renderErrorMessage } from 'common-components/view-logic'

const CoveragePeriodErrorMessages = ({ haveBasicPremiumState, coveragePeriod$ }) => {
  return (
    <div>
      {!enableCoveragePeriod(haveBasicPremiumState, coveragePeriod$) || isZero(coveragePeriod$)
        ? null
        : renderErrorMessage('error-coverage-period-message')(coveragePeriod$)}
    </div>
  )
}

export default CoveragePeriodErrorMessages
